import React, { useState, useEffect } from 'react';
import Field from './components/Field';
import Popup from '../../partials/OLIPopup';
import AudioPlayer from '../../UI/AudioPlayer';

const Survey = (props) => {
  console.log(props)
  const {
    data
  } = props;
  const {
    title,
    body,
    fields,
  } = data;

  const initialState = () => {
    return fields.map((field, i) => (
      {
        'key': `field_${i}`,
        'id': field.id ?? '',
        'v': ''
      }
    ))
  }
  const [showPopup, setShowPopup] = useState(false);
  const [surveyState, SetSurveyState] = useState(initialState ?? []);

  useEffect(() => {
    // console.log(props.data.popup !== undefined)
    if (props.data.popup !== undefined) {
      setShowPopup(true);

      // We dont want to autoPlay the intro
      if (props.data.popup.audio !== undefined) {
        setTimeout(() => {
          props.audioController.playAudioByName(props.data.popup.audio);
        }, 500);
      }
    } else {
      props.audioController.playAudioByName(props.data.audio);
    }
    return () => {
      // audio cleanup
      props.audioController.removeAudio(props.data.audio);
      if (props.data.popup) {
        props.audioController.removeAudio(props.data.popup.audio);
      }
    }
  }, [])

  const popupOnClick = () => {
    props.audioController.removeAudio(props.data.popup.audio);
    props.audioController.playAudioByName(props.data.audio);
    setShowPopup(false)
  }

  const updateState = (value, index) => {
    const newState = [...surveyState];
    newState[index].v = value
    SetSurveyState(newState);
  }

  const handleFormSubmit = () => {
    // httpRequest to survey endpoint only if data is not null
    console.log(surveyState)
    // Look for the name field to save it.
    const learnerName = surveyState.find(s => s.id === 'name');
    if (learnerName !== undefined) {
      // I created a state variable sharedData at App level because globalData was reseting when you change from one module to another.
      props.setSharedData({
        ...props.sharedData,
        learnerName: learnerName.v
      });
    }
    const surveyData = surveyState.reduce((prev, curr)=>{
      if (curr.id === 'name') return prev
      const nextField = {}
      nextField[curr.id] = {value:curr.v}
      return {...prev, ...nextField} 
    },{})
    props.handleSubmitSurvey(surveyData)

    // Then go to next pageIndex
    props.onComplete(surveyState);
  }

  return (<div className={`Survey ${data.class}`}>
    {props.data.audio &&
      <AudioPlayer audioController={props.audioController} audioCollection={props.audioCollection} />
    }
    {showPopup &&
      <Popup data={props.data.popup} onComplete={popupOnClick} />
    }
    {props.data.topRightOrange &&
        <div className={`top-right-orange ${!showPopup ? 'slide-left' : ''}`} />
    }
    {props.data.bottomLeftOrange &&
        <div className={`bottom-left-orange ${!showPopup ? 'slide-right' : ''}`} />
    }
    <div className={`left-content ${showPopup ? '' : 'post-popup'}`}>
      <div className={`header`} dangerouslySetInnerHTML={{ __html: title }} />
      <div className={`yellow-box`} />
      <div className='body-text' dangerouslySetInnerHTML={{ __html: body }} />
    </div>
    <div className={`clipboard ${showPopup ? '' : 'post-popup'}`}>
      <div className='fields'>
        {fields.map(((field, index) => <Field key={index} data={field} index={index} state={surveyState} updateState={updateState} />))}
        <button className='continue-button' onClick={handleFormSubmit}>{data.submitButtonText}</button>
      </div>
    </div>
  </div>)
}

export default Survey;